import Vue from 'vue'
import Router from 'vue-router'
// const Vue = require('vue')
// const Router = require('vue-router')

// import jibenmianView from '@/views/jibenmian/jibenmian-view/jibenmian-view'
// import jibenmianViewJbxx from '@/views/jibenmian/jibenmian-view/jibenmian-view-jbxx'
// import jibenmianViewYjbg from '@/views/jibenmian/jibenmian-view/jibenmian-view-yjbg'
// import jibenmianViewGsgg from '@/views/jibenmian/jibenmian-view/jibenmian-view-gsgg'
// import jibenmianViewMdcb from '@/views/jibenmian/jibenmian-view/jibenmian-view-mdcb'

// import chicang from '@/views/chicang/chicang'
// import chicangPhb from '@/views/chicang/chicang-phb'
// import chicangCgzt from '@/views/chicang/chicang-cgzt'
// import chicangCgztGg from '@/views/chicang/chicang-cgzt-gg'
// import chicangSsgs from '@/views/chicang/chicang-ssgs'
// import chicangSsgsGg from '@/views/chicang/chicang-ssgs-gg'

// import yanbao from '@/views/yanbao/yanbao'
// import xinxipilu from '@/views/xinxipilu/xinxipilu'
// import shujudingzhi from '@/views/shujudingzhi/shujudingzhi'
// import xuangu from '@/views/xuangu/xuangu'


Vue.use(Router)



const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: resolve => require(['@/views/home'], resolve)
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/views/login'], resolve)
    },
    {
      path: '/jibenmian',
      name: 'jibenmian',
      component: resolve => require(['@/views/jibenmian/jibenmian'], resolve)
    },
    {
      path: '/jibenmian/view',
      name: 'jibenmianView',
      component: resolve =>
        require(['@/views/jibenmian/jibenmian-view/jibenmian-view'], resolve),
      redirect: '/jibenmian/view-jyhq',
      children: [
        {
          path: '/jibenmian/view-jyhq',
          name: 'jibenmianViewJyhq',
          component: resolve =>
            require([
              '@/views/jibenmian/jibenmian-view/jibenmian-view-jyhq'
            ], resolve)
        },
        {
          path: '/jibenmian/view-jyhq-hk',
          name: 'jibenmianViewJyhq-hk',
          component: resolve =>
            require([
              '@/views/jibenmian/jibenmian-view/jibenmian-view-jyhq-hk'
            ], resolve)
        },
        {
          path: '/jibenmian/view-jbxx',
          name: 'jibenmianViewJbxx',
          component: resolve =>
            require([
              '@/views/jibenmian/jibenmian-view/jibenmian-view-jbxx'
            ], resolve)
        },
        {
          path: '/jibenmian/view-gdfx',
          name: 'jibenmianViewGdfx',
          component: resolve =>
            require([
              '@/views/jibenmian/jibenmian-view/jibenmian-view-gdfx'
            ], resolve)
        },
        {
          path: '/jibenmian/view-yjbg',
          name: 'jibenmianViewYjbg',
          component: resolve =>
            require([
              '@/views/jibenmian/jibenmian-view/jibenmian-view-yjbg'
            ], resolve)
        },
        {
          path: '/jibenmian/view-gsgg',
          name: 'jibenmianViewGsgg',
          component: resolve =>
            require([
              '@/views/jibenmian/jibenmian-view/jibenmian-view-gsgg'
            ], resolve)
        },
        {
          path: '/jibenmian/view-mdcb',
          name: 'jibenmianViewMdcb',
          component: resolve =>
            require([
              '@/views/jibenmian/jibenmian-view/jibenmian-view-mdcb'
            ], resolve)
        },
        {
          path: '/jibenmian/view-gzfx',
          name: 'jibenmianViewGzfx',
          component: resolve =>
            require([
              '@/views/jibenmian/jibenmian-view/jibenmian-view-gzfx'
            ], resolve)
        },
        {
          path: '/jibenmian/view-thdb',
          name: 'jibenmianViewThdb',
          component: resolve =>
            require([
              '@/views/jibenmian/jibenmian-view/jibenmian-view-thdb'
            ], resolve)
        }
      ]
    },

    {
      path: '/chicang',
      name: 'chicang',
      component: resolve => require(['@/views/chicang/chicang'], resolve),
      redirect: '/chicang/phb',
      children: [
        {
          path: '/chicang/phb',
          name: 'chicangPhb',
          component: resolve =>
            require(['@/views/chicang/chicang-phb'], resolve)
        },
        {
          path: '/chicang/cgzt',
          name: 'chicangCgzt',
          component: resolve =>
            require(['@/views/chicang/chicang-cgzt'], resolve)
        },
        {
          path: '/chicang/cgzt-gg',
          name: 'chicangCgztGg',
          component: resolve =>
            require(['@/views/chicang/chicang-cgzt-gg'], resolve)
        },
        {
          path: '/chicang/ssgs',
          name: 'chicangSsgs',
          component: resolve =>
            require(['@/views/chicang/chicang-ssgs'], resolve)
        },
        {
          path: '/chicang/ssgs-gg',
          name: 'chicangSsgsGs',
          component: resolve =>
            require(['@/views/chicang/chicang-ssgs-gg'], resolve)
        }
      ]
    },
    {
      path: '/yanbao',
      name: 'yanbao',
      component: resolve => require(['@/views/yanbao/yanbao'], resolve),
    },

    {
      path: '/xinxipilu',
      name: 'xinxipilu',
      component: resolve => require(['@/views/xinxipilu/xinxipilu'], resolve)
    },

    {
      path: '/shoufa',
      name: 'shoufa',
      component: resolve => require(['@/views/shoufa/shoufa'], resolve)
    },

    {
      path: '/datalab',
      name: 'datalab',
      component: resolve => require(['@/views/datalab/datalab'], resolve),
      redirect: '/datalab/hqsj-gg',
      children: [
        {
          path: '/datalab/scgk-gs',
          name: 'scgk-gs',
          component: resolve => require(['@/views/datalab/scgk-gs'], resolve)
        },
        {
          path: '/datalab/scgk-gsld',
          name: 'scgk-gsld',
          component: resolve => require(['@/views/datalab/scgk-gsld'], resolve)
        },
        {
          path: '/datalab/scgk-hy',
          name: 'scgk-hy',
          component: resolve => require(['@/views/datalab/scgk-hy'], resolve)
        },

        {
          path: '/datalab/hqsj-gg',
          name: 'hqsj-gg',
          component: resolve => require(['@/views/datalab/hqsj-gg'], resolve)
        },
        {
          path: '/datalab/hqsj-sc',
          name: 'hqsj-sc',
          component: resolve => require(['@/views/datalab/hqsj-sc'], resolve)
        },
        {
          path: '/datalab/hqsj-rzrq',
          name: 'hqsj-rzrq',
          component: resolve => require(['@/views/datalab/hqsj-rzrq'], resolve)
        },

        {
          path: '/datalab/cwfx-zb',
          name: 'cwfx-zb',
          component: resolve => require(['@/views/datalab/cwfx-zb'], resolve)
        },
        {
          path: '/datalab/cwfx-fh',
          name: 'cwfx-fh',
          component: resolve => require(['@/views/datalab/cwfx-fh'], resolve)
        },
        {
          path: '/datalab/cwfx-yg',
          name: 'cwfx-yg',
          component: resolve => require(['@/views/datalab/cwfx-yg'], resolve)
        },
        {
          path: '/datalab/cwfx-kb',
          name: 'cwfx-kb',
          component: resolve => require(['@/views/datalab/cwfx-kb'], resolve)
        },
        {
          path: '/datalab/cwfx-yc',
          name: 'cwfx-yc',
          component: resolve => require(['@/views/datalab/cwfx-yc'], resolve)
        },
        {
          path: '/datalab/cwfx-bg',
          name: 'cwfx-bg',
          component: resolve => require(['@/views/datalab/cwfx-bg'], resolve)
        },

        {
          path: '/datalab/gdbd-hs',
          name: 'gdbd-hs',
          component: resolve => require(['@/views/datalab/gdbd-hs'], resolve)
        },
        {
          path: '/datalab/gdbd-cm',
          name: 'gdbd-cm',
          component: resolve => require(['@/views/datalab/gdbd-cm'], resolve)
        },
        {
          path: '/datalab/gdbd-cc',
          name: 'gdbd-cc',
          component: resolve => require(['@/views/datalab/gdbd-cc'], resolve)
        },
        {
          path: '/datalab/gdbd-gree',
          name: 'gdbd-gree',
          component: resolve => require(['@/views/datalab/gdbd-gree'], resolve)
        },
        {
          path: '/datalab/gdbd-sf',
          name: 'gdbd-sf',
          component: resolve => require(['@/views/datalab/gdbd-sf'], resolve)
        },


        {
          path: '/datalab/shgt-bx',
          name: 'shgt-bx',
          component: resolve => require(['@/views/datalab/shgt-bx'], resolve)
        },
        {
          path: '/datalab/shgt-nx',
          name: 'shgt-nx',
          component: resolve => require(['@/views/datalab/shgt-nx'], resolve)
        },

        {
          path: '/datalab/gzd-gg',
          name: 'gzd-gg',
          component: resolve => require(['@/views/datalab/gzd-gg'], resolve)
        },
        {
          path: '/datalab/gzd-hy',
          name: 'gzd-hy',
          component: resolve => require(['@/views/datalab/gzd-hy'], resolve)
        },

        {
          path: '/datalab/jgdy-hz',
          name: 'jgdy-hz',
          component: resolve => require(['@/views/datalab/jgdy-hz'], resolve)
        },
        {
          path: '/datalab/tactics-E3',
          name: 'tactics-E3',
          component: resolve => require(['@/views/datalab/tactics-E3'], resolve)
        },
        {
          path: '/datalab/tactics-E6',
          name: 'tactics-E6',
          component: resolve => require(['@/views/datalab/tactics-E6'], resolve)
        },
        {
          path: '/datalab/tactics-S2',
          name: 'tactics-S2',
          component: resolve => require(['@/views/datalab/tactics-S2'], resolve)
        },
        {
          path: '/datalab/tactics-S4',
          name: 'tactics-S4',
          component: resolve => require(['@/views/datalab/tactics-S4'], resolve)
        },
        {
          path: '/datalab/tactics-S6',
          name: 'tactics-S6',
          component: resolve => require(['@/views/datalab/tactics-S6'], resolve)
        },
        {
          path: '/datalab/tactics-holder',
          name: 'tactics-holder',
          component: resolve => require(['@/views/datalab/tactics-holder'], resolve)
        },
        {
          path: '/datalab/tactics-main',
          name: 'tactics-main',
          component: resolve => require(['@/views/datalab/tactics-main'], resolve)
        },
        {
          path: '/datalab/yjyqc-dc',
          name: 'yjyqc-dc',
          component: resolve => require(['@/views/datalab/yjyqc-dc'], resolve)
        },
        {
          path: '/datalab/bf-gjc',
          name: 'bf-gjc',
          component: resolve => require(['@/views/datalab/bf-gjc'], resolve)
        },

      ]
    },
    {
      path: '/user-favorite',
      name: 'user-favorite',
      component: resolve => require(['@/views/user/user-favorite'], resolve)
    }
  ]
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


export default router



// WEBPACK FOOTER //
// ./src/router/router.js